import axiosInstance from "./api";

export const userService = {
  register: (newUser) => axiosInstance.post("register", newUser),
  login: (user) => axiosInstance.post("login", user),
  logout: () => axiosInstance.get("profile/logout"),
  myProfile: () => axiosInstance.get("profile"),
};
